/**
 * 移动端 Header 修复脚本
 * 专门解决 about-us 页面在移动端的重叠问题
 */
class MobileHeaderFix {
  constructor() {
    this.isMobile = window.innerWidth <= 1023;
    this.isAboutPage = window.location.pathname === '/pages/about-us';
    this.header = document.querySelector('.header');
    this.headerSection = document.querySelector('.header-section');
    this.mainContent = document.querySelector('.main-content');
    
    // 临时禁用选项 - 如果出现问题，设置为 true
    this.disabled = false;
    
    this.init();
  }

  init() {
    if (this.disabled) {
      console.log('Mobile Header Fix: 已禁用');
      return;
    }
    
    if (!this.isMobile || !this.isAboutPage) return;
    
    console.log('Mobile Header Fix: 初始化移动端 header 修复');
    
    // 延迟应用修复，确保页面完全加载
    setTimeout(() => {
      this.applyHeaderFix();
    }, 100);
    
    // 监听滚动事件
    window.addEventListener('scroll', this.handleScroll.bind(this), { passive: true });
    
    // 监听窗口大小变化
    window.addEventListener('resize', this.handleResize.bind(this), { passive: true });
    
    // 监听 DOM 变化
    this.observeDOMChanges();
  }

  applyHeaderFix() {
    if (!this.header || !this.headerSection) return;

    // 只修复 z-index 层级，保持原有样式
    this.header.style.setProperty('z-index', '100', 'important');
    this.headerSection.style.setProperty('z-index', '100', 'important');
    
    // 修复 video-with-text-overlay 的 z-index
    const bannerContent = document.querySelector('.video-with-text-overlay .banner__content');
    if (bannerContent) {
      bannerContent.style.setProperty('z-index', '10', 'important');
    }
    
    const bannerBox = document.querySelector('.video-with-text-overlay .banner__box');
    if (bannerBox) {
      bannerBox.style.setProperty('position', 'relative', 'important');
      bannerBox.style.setProperty('z-index', '1', 'important');
    }
  }



  handleScroll() {
    if (!this.header) return;
    
    const scrollTop = window.scrollY;
    const isScrolled = scrollTop > 50;
    const isTransparent = this.headerSection.classList.contains('header-transparent');
    
    // 只在滚动时且 header 透明时应用背景修复
    if (isScrolled && isTransparent) {
      this.header.style.setProperty('background-color', 'rgb(var(--color-background))', 'important');
      this.header.style.setProperty('--header-background-opacity', '1', 'important');
      this.header.style.setProperty('box-shadow', '0 2px 10px rgba(0, 0, 0, 0.1)', 'important');
    } else if (!isScrolled && isTransparent) {
      // 回到顶部时恢复透明状态
      this.header.style.removeProperty('background-color');
      this.header.style.removeProperty('--header-background-opacity');
      this.header.style.setProperty('box-shadow', 'none', 'important');
    }
    
    // 调试信息
    if (window.location.hostname === 'localhost' || window.location.hostname.includes('dev')) {
      console.log('Mobile Header Fix:', {
        scrollTop,
        isScrolled,
        isTransparent,
        headerHeight: this.header.offsetHeight,
        headerZIndex: getComputedStyle(this.header).zIndex
      });
    }
  }

  handleResize() {
    const newIsMobile = window.innerWidth <= 1023;
    
    if (newIsMobile !== this.isMobile) {
      this.isMobile = newIsMobile;
      if (this.isMobile && this.isAboutPage) {
        this.applyHeaderFix();
      }
    }
  }

  observeDOMChanges() {
    // 监听 header 相关元素的变化
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes' && 
            (mutation.target.classList.contains('header') || 
             mutation.target.classList.contains('header-section'))) {
          this.applyHeaderFix();
        }
      });
    });
    
    if (this.headerSection) {
      observer.observe(this.headerSection, {
        attributes: true,
        subtree: true,
        attributeFilter: ['class', 'style']
      });
    }
  }
}

// 页面加载完成后初始化
document.addEventListener('DOMContentLoaded', () => {
  new MobileHeaderFix();
});

// 如果 DOM 已经加载完成，立即初始化
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new MobileHeaderFix();
  });
} else {
  new MobileHeaderFix();
}
